module.exports = __webpack_public_path__ + "img/Keaton_Miller.10ea76c8.jpg";